import React, {useState, useRef} from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import {isEmail} from "validator";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Title from "../dashboard/Title";
import {PhotoCamera} from "@material-ui/icons";

import AuthService from "../../services/auth.service";
import {useDashboardStyles, BRAND} from "../settings/dashboardStyles";

const useLocalStyles = makeStyles((theme) => ({
    label: {
        display: "block",
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: "uppercase",
        color: BRAND.inkSoft,
        marginBottom: 6,
    },
    input: {
        width: "100%",
        padding: theme.spacing(1.25, 1.5),
        background: BRAND.creamSoft,
        border: `1.5px solid ${BRAND.goldSoft}`,
        borderRadius: 10,
        fontSize: "1rem",
        color: BRAND.ink,
        fontFamily: "inherit",
        transition: "border-color 150ms ease, background 150ms ease, box-shadow 150ms ease",
        boxSizing: "border-box",
        "&:focus": {
            outline: "none",
            background: "#ffffff",
            borderColor: BRAND.deep,
            boxShadow: "0 0 0 3px rgba(44, 71, 103, 0.12)",
        },
    },
    field: {
        marginBottom: theme.spacing(2),
    },
    fileLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(1.25, 1.75),
        background: BRAND.creamSoft,
        border: `1.5px solid ${BRAND.goldSoft}`,
        borderRadius: 10,
        color: BRAND.deep,
        fontWeight: 600,
        fontSize: "0.92rem",
        cursor: "pointer",
        transition: "background 180ms ease, border-color 180ms ease",
        "&:hover": {
            background: BRAND.goldBg,
            borderColor: BRAND.gold,
        },
        "& svg": {fontSize: 20},
    },
    filename: {
        marginTop: theme.spacing(0.75),
        fontSize: "0.85rem",
        color: BRAND.inkSoft,
        fontStyle: "italic",
    },
    submit: {
        background: `linear-gradient(135deg, ${BRAND.deep} 0%, ${BRAND.deepDark} 100%)`,
        color: "#ffffff",
        fontWeight: 600,
        fontSize: "1rem",
        textTransform: "none",
        padding: theme.spacing(1.25, 3),
        border: 0,
        borderRadius: 10,
        cursor: "pointer",
        boxShadow: "0 6px 18px rgba(44, 71, 103, 0.25)",
        transition: "transform 120ms ease, box-shadow 200ms ease",
        "&:hover": {
            boxShadow: "0 10px 26px rgba(44, 71, 103, 0.35)",
            transform: "translateY(-1px)",
        },
    },
    alertError: {
        marginTop: theme.spacing(0.5),
        padding: theme.spacing(0.75, 1.25),
        background: "rgba(248, 50, 69, 0.08)",
        color: "#a8324a",
        border: "1px solid rgba(248, 50, 69, 0.22)",
        borderRadius: 8,
        fontSize: "0.85rem",
    },
    alertSuccess: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        background: BRAND.successBg,
        color: BRAND.success,
        border: `1px solid ${BRAND.successBorder}`,
        borderRadius: 10,
        fontSize: "0.95rem",
    },
    actionsRow: {
        marginTop: theme.spacing(3),
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        flexWrap: "wrap",
    },
}));

const required = (value, localClasses) => {
    if (!value) {
        return <div className={localClasses.alertError}>Toto pole je povinné!</div>;
    }
};

const validEmail = (value, localClasses) => {
    if (!isEmail(value)) {
        return <div className={localClasses.alertError}>Toto nie je platný email.</div>;
    }
};

const vusername = (value, localClasses) => {
    if (value.length < 3 || value.length > 20) {
        return <div className={localClasses.alertError}>Pole musí mať 3 až 20 znakov.</div>;
    }
};

const vpassword = (value, localClasses) => {
    if (value.length < 6 || value.length > 40) {
        return <div className={localClasses.alertError}>Heslo musí mať 6 až 40 znakov.</div>;
    }
};

const Register = () => {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();
    const form = useRef();
    const checkBtn = useRef();

    const [user, setUser] = useState({
        username: '',
        email: '',
        password: '',
        name: '',
        address: '',
        ico: '',
        ic_dph: '',
        phone: '',
        logo: null,
        email_official: '',
        web: '',
        default_signature_place: ''
    });
    const [successful, setSuccessful] = useState(false);
    const [message, setMessage] = useState("");

    const handleUser = (name) => (e) => {
        setUser({...user, [name]: e.target.value});
    };

    const handleLogo = (e) => {
        setUser({...user, 'logo': e.target.files[0]})
    }

    const handleRegister = (e) => {
        e.preventDefault();

        setMessage("");
        setSuccessful(false);

        form.current.validateAll();
        const data = new FormData();
        if (checkBtn.current.context._errors.length === 0) {
            data.append('username', user.username);
            data.append('email', user.email);
            data.append('password', user.password);
            data.append('name', user.name);
            data.append('address', user.address);
            data.append('ico', user.ico);
            data.append('ic_dph', user.ic_dph);
            data.append('phone', user.phone);
            data.append('email_official', user.email_official);
            data.append('web', user.web);
            data.append('default_signature_place', user.default_signature_place);
            data.append('someimage', user.logo, user.logo.name);
            AuthService.register(data).then(
                (response) => {
                    setMessage(response.data.message);
                    setSuccessful(true);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    setMessage(resMessage);
                    setSuccessful(false);
                }
            );
        }
    };

    const requiredCls = (v) => required(v, localClasses);
    const emailCls = (v) => validEmail(v, localClasses);
    const usernameCls = (v) => vusername(v, localClasses);
    const passwordCls = (v) => vpassword(v, localClasses);

    const renderField = (label, name, opts = {}) => (
        <div className={localClasses.field}>
            <label className={localClasses.label} htmlFor={name}>{label}</label>
            <Input
                id={name}
                type={opts.type || "text"}
                className={localClasses.input}
                name={name}
                value={user[name]}
                onChange={handleUser(name)}
                validations={opts.validations || []}
            />
        </div>
    );

    return (
        <Container maxWidth="md" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <Title>Registrácia nového používateľa</Title>
                </div>

                <Form onSubmit={handleRegister} ref={form}>
                    {!successful && (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Používateľské meno", "username", {validations: [requiredCls, usernameCls]})}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Email", "email", {validations: [requiredCls, emailCls]})}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Heslo", "password", {type: "password", validations: [requiredCls, passwordCls]})}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Telefón", "phone")}
                                </Grid>
                                <Grid item xs={12}>
                                    {renderField("Názov spoločnosti", "name")}
                                </Grid>
                                <Grid item xs={12}>
                                    {renderField("Adresa", "address")}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Email na komunikáciu", "email_official")}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("Web", "web")}
                                </Grid>
                                <Grid item xs={12}>
                                    {renderField("Prednastavené miesto podpisu", "default_signature_place")}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("IČO", "ico", {validations: [requiredCls, usernameCls]})}
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {renderField("IČ DPH", "ic_dph")}
                                </Grid>
                            </Grid>

                            <div className={localClasses.field} style={{marginTop: 16}}>
                                <label className={localClasses.label}>Logo</label>
                                <input
                                    accept="image/*"
                                    style={{display: "none"}}
                                    id="register-logo-input"
                                    type="file"
                                    onChange={handleLogo}
                                />
                                <label htmlFor="register-logo-input" className={localClasses.fileLabel}>
                                    <PhotoCamera/>
                                    Vybrať logo
                                </label>
                                {user.logo && user.logo.name && (
                                    <div className={localClasses.filename}>{user.logo.name}</div>
                                )}
                            </div>

                            <div className={localClasses.actionsRow}>
                                <button type="submit" className={localClasses.submit}>
                                    Vytvoriť účet
                                </button>
                            </div>
                        </>
                    )}

                    {message && (
                        <div className={successful ? localClasses.alertSuccess : localClasses.alertError}>
                            {message}
                        </div>
                    )}
                    <CheckButton style={{display: "none"}} ref={checkBtn}/>
                </Form>
            </Paper>
        </Container>
    );
};

export default Register;
